<template>
    <div>

        <v-offline
                online-class="online"
                offline-class="offline"
                @detected-condition="amIOnline">
            <template v-slot:[onlineSlot] :slot-name="onlineSlot">
                {{ onlineOfflineMsg }}
            </template>
            <template v-slot:[offlineSlot] :slot-name="offlineSlot">
                {{ onlineOfflineMsg }}
            </template>
        </v-offline>
        <div class="row">
            <div class="col-lg-12">
                <div class="ibox ">
                    <div class="ibox-content">
                        <div class="panel-heading">
                            <h2 class="set_font_title">Survey Records</h2>
                        </div>
                        <survey-record-list :project-id="projectId"></survey-record-list>
                        <div class="row setMarginTop set_res_margin_top">
                            <div class="col-xs-12 col-md-12 col-xl-12">
                                <div class="row setTitleDiv">
                                    <p>By Project Areas</p>
                                </div>
                                <div class="row setMarginTop set_res_margin_top">
                                    <!--                                    <div class="col-xs-6 col-sm-12 col-md-6 col-xl-3">
                                                                            <span style="color: #4285f4;">Select Filter</span>
                                                                            <div class="form-group">
                                                                                <template>
                                                                                    <el-select v-model="selectFilter" filterable placeholder="All"
                                                                                               class="el_select_width">
                                                                                        <el-option
                                                                                                v-for="area in filterArrAreas"
                                                                                                :key="area.id"
                                                                                                :label="area.name"
                                                                                                :value="area.key">
                                                                                        </el-option>
                                                                                    </el-select>
                                                                                </template>
                                                                            </div>
                                                                        </div>-->
                                    <div class="col-xs-6 col-sm-12 col-md-6 col-xl-3" v-if="!inputshow">
                                        <fg-input type="text" style="margin-top: 23px;" :placeholder="placeholderVal"
                                                  name="selectFilterVal" v-model="selectFilterVal">
                                        </fg-input>
                                    </div>
                                    <div class="col-xs-6 col-sm-12 col-md-6 col-xl-3" v-if="!daterangPicker">
                                        <span style="color: #4285f4;">Select Date Range</span>
                                        <v-md-date-range-picker :presets="dateRangePresets" :start-date="startDatePast" :end-date="endDatePast"
                                                                @change="handleChange"
                                                                style="width:100% !important"></v-md-date-range-picker>
                                    </div>
                                </div>
                                <p></p>
                                <div class="setMarginTop set_res_margin_top" v-if="filteredVaccinationArea.length == 0"
                                     style="text-align: center;">
                                    <p class="no_rec_msg">No Records found</p>
                                </div>

                                <div class="row setMarginTop">
                                    <!--                            <div class="col-md-12">
                                                                    <get-stats />
                                                                </div>-->
                                    <div class="col-xs-6 col-sm-12 col-md-4 col-xl-4 set_cursor"
                                         v-for="item in filteredVaccinationArea" :key="item.id"
                                         @click="areaDetail(item)">
                                        <area-card
                                                :areaId="item.id"
                                                :areaImage="item.areaImage"
                                                :title="item.name"
                                                :vaccination-count="item.vaccinations_count"
                                                :survey-count="item.surveys_count"
                                                :country="item.google_country"
                                                :createdOn="item.created_at"
                                                :areaState="item.google_admin_area_level1!='null'?item.google_admin_area_level1:'Not specified'"
                                                :locality="item.google_locality!='null'?item.google_locality:'Not specified'"
                                                :fieldUsers="item.assigned_areas"
                                                :areaStatus="item.status"
                                                :statusColor="item.status_color_code"
                                                :vaccinationStatus="item.status_info.vaccination"
                                                :surveyStatus="item.status_info.survey"
                                        ></area-card>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import mixin from '../../mixins/GlobalMixin';
import dateRangeDefaultPresetsMixin from '../../mixins/DateRangeDefaultPresetsMixin';
import AreaCard from "./UIComponents/Cards/VaccinationRecordCard.vue";
import GetStats from '../modules/GetStats.vue'
import {Select, Option,} from 'element-ui';
import Swal from 'sweetalert2';
import VOffline from 'v-offline';
import Vue from 'vue';
import VMdDateRangePicker from "v-md-date-range-picker";

import SurveysRecordDetailList from "./SurveysRecordDetailList";

Vue.use(VMdDateRangePicker);

export default {
    components: {
        "area-card": AreaCard,
        [Option.name]: Option,
        [Select.name]: Select,
        VOffline,
        GetStats,
        "survey-record-list": SurveysRecordDetailList,
    },
    props: {
        projectId: {
            type: Number,
        }
    },
    data()
    {
        return {
            areaId: '',
            title: '',
            createdOn: '',
            country: '',
            areaState: '',
            locality: '',
            fieldUsers: '',
            areaImage: '',
            selectFilter: "",
            selectFilterVal: "",
            project: null,
            area: [],
            filterArrAreas: [
                {id: 1, name: 'All', 'key': 'all'},
                {id: 2, name: 'Created On', 'key': 'created_at'},
                {id: 3, name: 'Modifed On', 'key': 'last_modified'},
                {id: 4, name: 'Country', 'key': 'country'},
                {id: 5, name: 'State/Province', 'key': 'google_admin_area_level1'},
                {id: 6, name: 'City/District/Village', 'key': 'google_locality'},
            ],
            stratDate: '',
            endDate: '',
            inputshow: true,
            daterangPicker: true,
            placeholderVal: "",
            survey_percentage: "",
            startDatePast: '',
            endDatePast: '',
            dateRangePresets: []
        }
    },
    mixins: [mixin, dateRangeDefaultPresetsMixin],
    methods: {
        FilterAreas()
        {
            console.log("filter click");
        },
        handleChange(values)
        {
            var sDate = this.formatDate(values[0]._d);
            var eDate = this.formatDate(values[1]._d);
            this.stratDate = sDate;
            this.endDate = eDate;
        },
        formatDate(date)
        {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('-');
        },
        viewProjectSurveyOnMap()
        {
            localStorage.setItem('surveyProjectLevelViewMap', 1);
            this.$router.push({name: 'projectSurveyMapview', params: {projectId: this.projectId}})
        },
        showAllKMLs()
        {
            window.location = '/project/map_kml_files/' + this.projectId;
        },
        listProjectSurveys()
        {
            localStorage.setItem('surveyProjectLevelViewList', 1);
            this.$router.push({name: 'projectSurveyList', params: {projectId: this.projectId}})
        },
        getArea()
        {
            axios.get("/area?project_id=" + this.projectId)
                .then(response => {
                    if (response.data.response.error.error_code == 0) {
                        this.area = response.data.response.data;
                    }
                })
                .catch(error => {
                    if (error.response.data.response.error) {

                    }
                });
        },
        areaDetail(item)
        {
            Bus.$emit("area_id", item.id);
            localStorage.setItem("SurveyAreaName", item.name)
            localStorage.setItem("SurveyAreaId", item.id)
            localStorage.setItem("selectedArea", item.id)
            localStorage.setItem("surveyProjectLevelViewList", 0)
            this.$router.push({name: 'areaSurveyList', params: {projectId: this.projectId, areaId: item.id}})
        },
    },
    computed: {
        filteredVaccinationArea: function () {
            var type = this.selectFilter;
            if (type == "country" || type == "google_admin_area_level1" || type == "google_locality") {
                this.daterangPicker = true;
                this.inputshow = false;
                if (type == "country") {
                    this.placeholderVal = "Enter Country";
                } else
                    if (type == "google_admin_area_level1") {
                        this.placeholderVal = "Enter State/Province";
                    } else
                        if (type == "google_locality") {
                            this.placeholderVal = "Enter City/District/Village";
                        }
                if (this.selectFilter && this.selectFilterVal) {
                    return this.area.filter(item => {
                        if (item[type] != null) {
                            return (
                                item[type].toLowerCase().indexOf(this.selectFilterVal.toLowerCase()) > -1
                            );
                        }
                    });
                } else {
                    return this.area.filter(item => {
                        return item
                    });
                }
            } else
                if (type == "last_modified" || type == "created_at") {
                    this.inputshow = true;
                    this.daterangPicker = false;
                    try {
                        setTimeout(function () {
                            var x = document.getElementsByTagName("label")[0].textContent = "";
                        }, 50);
                    } catch (e) {
                    }
                    if (this.selectFilter && this.stratDate && this.endDate) {
                        return this.area.filter(item => {
                            return (
                                new Date(this.formatDate(item[type])) >= new Date(this.stratDate) && new Date(this.formatDate(item[type])) <= new Date(this.endDate)
                            );
                        });
                    } else {
                        return this.area.filter(item => {
                            return item
                        });
                    }
                } else {
                    this.daterangPicker = true;
                    this.inputshow = true;
                    return this.area.filter(item => {
                        return item
                    });
                }
        },
        getSurveyedAnimalsCount: function () {
            let count = 0;
            for (let i = 0; i < this.area.length; i++) {
                count = count + this.area[i].surveys_count;
            }

            let percentage = 0;
            for (let i = 0; i < this.area.length; i++) {
                percentage = percentage + this.area[i].status_info.survey.percentage_covered;
            }
            //percentage=percentage/count;
            percentage = percentage / this.area.length;
            percentage = percentage.toFixed(1);

            return count + ' (' + percentage + '%)';
        }
    },
    mounted()
    {
        this.getArea();
        let vm = this;
        vm.project = vm.$store.getters.getCurrentSelectedProject;
        vm.survey_percentage = vm.project.survey_percentage;
        //Bus.$emit("projectype", vm.project);
        var date = new Date();
        var firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
        var lastDay = new Date(date.getFullYear(), date.getMonth() - 1 + 1, 0);
        this.startDatePast = firstDay.toLocaleDateString('en-US');
        this.endDatePast = lastDay.toLocaleDateString('en-US');
        this.dateRangePresets = this.getDateRangePresets();
    }
}

</script>
<style scoped>
.pac-card {
    margin: 10px 10px 0 0;
    border-radius: 2px 0 0 2px;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    outline: none;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    background-color: #fff;
}

#pac-container {
    padding-top: 12px;
    padding-bottom: 12px;
    margin-right: 12px;
}

.pac-controls label {
    font-size: 13px;
    font-weight: 300;
}

#pac-input {
    background-color: #fff;
    font-size: 15px;
    font-weight: 300;
    margin-left: 12px;
    padding: 0 11px 0 13px;
    text-overflow: ellipsis;
    width: 400px;
}

#pac-input:focus {
    border-color: #4d90fe;
}

#title {
    color: #fff;
    background-color: #4d90fe;
    font-size: 25px;
    font-weight: 500;
    padding: 6px 12px;
}

.setTitleDiv p {
    font-size: 17px;
    font-weight: 600;
    color: black;
}

.el_select_width {
    width: 100% !important;
}

.setShadow {
    box-shadow: 0 6px 10px 0px rgba(0, 0, 0, 0.15) !important;
}

.card .numbers p {
    color: #9A9A9A;
    font-size: 14px;
}

.card .numbers {
    font-size: 1.5em !important;
}

.card .card-body {
    text-align: center;
}

.set_b_font_card {
    font-size: 17px !important;
    color: #9a9a9a !important;
}

.set_btn {
    text-align: right;
    margin-top: -5px;
}

@media (max-width: 768px) {
    .set_btn {
        text-align: center !important;
        margin-top: -5px;
    }
}

.btn_card {
    cursor: pointer;
    height: 107px;
}

.no_rec_msg {
    font-size: 20px;
    height: 220px;
}

.text-field__filled {
    display: block;
    font-size: 18px;
    padding: 4px 10px 10px 5px;
    width: 100% !important;
    border: none;
    border-bottom: 1px solid #757575;
}

.set_font_title {
    font-size: 20px !important;
    font-weight: 600 !important;
    color: black !important;
    margin-left: -12px !important;
}

.area-card-footer {
    position: absolute;
    margin-top: -60px;
    margin-left: 185px;
}

@media (min-width: 320px)and (max-width: 374px) {
    .area-card-footer {
        position: absolute;
        margin-top: -60px;
        margin-left: 70px;
    }
}

@media (min-width: 375px)and (max-width: 424px) {
    .area-card-footer {
        position: absolute;
        margin-top: -60px;
        margin-left: 90px;
    }
}

@media (min-width: 425px)and (max-width: 767px) {
    .area-card-footer {
        position: absolute;
        margin-top: -60px;
        margin-left: 120px;
    }
}

@media (min-width: 768px)and (max-width: 769px) {
    .area-card-footer {
        position: absolute;
        margin-top: -60px;
        margin-left: 300px;
    }
}

@media (min-width: 1024px)and (max-width: 1025px) {
    .area-card-footer {
        position: absolute;
        margin-top: -47px;
        margin-left: 25px;
    }
}

@media (min-width: 1440px)and (max-width: 1441px) {
    .area-card-footer {
        position: absolute;
        margin-top: -60px;
        margin-left: 100px;
    }
}

.set_cursor {
    cursor: pointer;
}
</style>
